import React, { useEffect, useMemo, useState, useCallback } from "react";
import styles from "./StatusTip.module.less"
import { WithTranslation, withTranslation } from "react-i18next";
import IconFont from "@/components/icon";
import { connect } from "dva";
import { MessageCategoryType, MessageNotifyType } from "@/types/chat/enum";
import ChatState from "@/types/chat/State";
import ConnectState from "@jd/jdee.im.sdk/lib/es/enum/ConnectState";
import lifecycle from "page-lifecycle";
import { FocusSDK } from "@/utils";
import dayjs from "dayjs";
import { usePrevious, useThrottle } from "@/utils/chat/index";
import { debounce, throttle } from "lodash";
import { getNetCheckUrl } from "@/config/config";
import Bus from "@/utils/bus";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";

interface MsgNotificationProps {
  showSyncMsgTip?: boolean;
}

type IProps = Readonly<MsgNotificationProps & WithTranslation & ChatState>;


function StatusTip(props: IProps) {

  const { t, connectState, showSyncMsgTip } = props;
  const [changeActive, setChangeActive] = useState(false);
  const preActive = usePrevious(changeActive);


  // 激活会话窗口时，更新连接状态
  const changeHidden = (event: any) => {
    const { newState } = event;
    if (newState === "active") {
      setChangeActive(true);
    } else {
      setChangeActive(false);
    }
  };

  useEffect(() => {
    lifecycle.addEventListener("statechange", changeHidden);
    return () => {
      lifecycle.removeEventListener("statechange", changeHidden);
    };
  }, []);

  const netCheck = useCallback(() => {
    const netServer = NetworkCheck.getInstance({
      url: getNetCheckUrl(),
      checkType: UseCheckType.API
    });
    FocusSDK.printLog(`${dayjs().format("YYYY-MM-DD HH:mm:ss.SSS")},连接状态当前值检测docheck`);
    netServer.checkNet().then((isOnline) => {
      if (isOnline) {
        Bus.emit("chat:state", {
          state: ConnectState.READY
        });
      }
    });
  }, []);

  const doNetCheck = useThrottle(netCheck, 30 * 1000);

  useEffect(() => {
    if (
      [ConnectState.OFFLINE, ConnectState.CLOSED].includes(connectState.state) &&
      !preActive &&
      changeActive
    ) {
      doNetCheck();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeActive, connectState.state, preActive]);

  let msgTitle = useMemo(() => {
    let msgTitle = t("connection-status.on-connection");
    switch (connectState.state) {
      case ConnectState.OFFLINE:
      case ConnectState.ERROR:
        msgTitle = t("connection-status.connection-closed");
        break;
      case ConnectState.CLOSED:
      case ConnectState.CONNECTING:
      case ConnectState.CONNECTED:
        msgTitle = t("connection-status.on-connection");
        break;
      case ConnectState.AUTHING:
        msgTitle = t("connection-status.on-receive");
        break;
      // case ConnectState.AUTH_FAILED:
      //     msgTitle = t('connection-status.authentication-failed');
      //     break;
      case ConnectState.AUTHED:
      case ConnectState.READY:
        // msgTitle = t(notifyType[selectedNotifyType].title);
        msgTitle = "";

        break;
    }
    return msgTitle;
  }, [connectState.state, t, changeActive]); // eslint-disable-line



  
  return (
    <div>
          {!msgTitle || [ConnectState.AUTHED, ConnectState.READY].includes(connectState.state) ? (
            null
          ) : (
            <div className={styles["status-tip-wrap"]}>{msgTitle ? msgTitle : ""}</div>
          )}
          {showSyncMsgTip && <div className={styles["status-tip-wrap"]}>{t("message is syncchronizing")}</div>}
        </div>
  ) ;
}

function mapStateToProps({ chat }: { chat: ChatState }) {
  const {
    selectedCategory,
    category,
    connectState
  } = chat;
  return {
    selectedCategory,
    category,
    connectState
  };
}

export default connect(
  mapStateToProps
)(withTranslation("chat")(StatusTip));
